var _rect, _rect2, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCimb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 50,
    viewBox: "0 0 70 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2694_262)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 6.63158,
    fill: "#EE3124"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2694_262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 50
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 6.63158,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2694_262)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2694_262)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2694_262)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 32.7968H21.9888V17H6V32.7968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6573 19.9849H8.16064L11.9231 24.8976H20.4205L16.6573 19.9849Z",
    fill: "#ED3124"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.42 24.8979H11.9226L8.16016 29.8103H16.6568L20.42 24.8979Z",
    fill: "#820024"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4783 28.1976H58.4065V25.7627H60.4783C61.4447 25.7627 61.7905 26.3885 61.7905 26.9738C61.7905 27.5658 61.4447 28.1976 60.4783 28.1976ZM58.4065 21.5978H60.3465C61.1604 21.5978 61.6451 22.022 61.6451 22.7372C61.6451 23.4501 61.1604 23.8739 60.3465 23.8739H58.4065V21.5978ZM62.5321 24.7669C62.9968 24.515 63.7591 23.8055 63.7591 22.6497C63.7591 20.8447 62.5128 19.7214 60.5062 19.7214H56.2914V30.0722H60.6836C62.6699 30.0722 63.9048 28.9255 63.9048 27.075C63.9048 25.6849 63.0793 25.0401 62.5321 24.7669ZM48.0607 26.3346C47.9812 26.2002 44.3603 19.7009 44.3603 19.7009H42.2916V30.0525H44.4055V23.8687C44.5664 24.1396 48.0607 30.1362 48.0607 30.1362C48.0607 30.1362 51.5388 24.1403 51.694 23.8702V30.0525H53.8102V19.7009H51.7425C51.7425 19.7009 48.1345 26.2002 48.0607 26.3346ZM37.5815 30.0722H39.703V19.7214H37.5815V30.0722ZM34.0785 27.5789C33.4616 28.0655 32.7148 28.3216 31.9276 28.3216C30.0163 28.3216 28.5297 26.8183 28.5297 24.8979C28.5297 22.9772 30.0163 21.4728 31.9276 21.4728C32.7148 21.4728 33.4616 21.7292 34.0785 22.2166L34.1079 22.2397L35.582 20.7841L35.5485 20.7532C34.5399 19.8922 33.2564 19.417 31.9276 19.417C28.8352 19.417 26.3193 21.8762 26.3193 24.8979C26.3193 27.9189 28.8352 30.3774 31.9276 30.3774C33.2564 30.3774 34.5399 29.9033 35.5485 29.0423L35.582 29.0099L34.1079 27.5558L34.0785 27.5789Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2694_262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2694_262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 16,
    fill: "white",
    transform: "translate(6 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2694_262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCimb);
export default __webpack_public_path__ + "static/media/cimb.21e14a5ee917b3007378528162422898.svg";
export { ForwardRef as ReactComponent };